import React from "react";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import useMediaQuery from '@mui/material/useMediaQuery';
import useTheme from '@mui/material/styles/useTheme';
import {
    useQuery,
    UseQueryResult
} from 'react-query';
import { QRCodeSVG } from "qrcode.react";
import { HttpClient } from 'apiclient/ApiClient';

export interface QrCodesResponse {
    class_name: string;
    members: [{
        id: string,
        name: string;
        url: string;
        role: 'student' | 'teacher';
    }];
};



export const QrCodesUpdated = (
    props: {
        class_id: string,
        selectedProfileId?: string,
    }
) => {
    const theme = useTheme();
    const httpClient = HttpClient();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    // TODO: implement personal deeplink query
    const deepLinksQuery: UseQueryResult<QrCodesResponse> = useQuery(
        `/classes/${props.class_id}/deeplinks`,
        async () => await httpClient.get(`/school/classes/${props.class_id}/deeplinks`)
    );

    const qr = React.useMemo(() => {
        const info = deepLinksQuery.data?.members.filter(m => m.id === props.selectedProfileId).at(0);
        const url = info?.url;
        const name = info?.name;
        if (url && name) {
            return (
                <>
                    <QRCodeSVG
                        size={matches ? 320 : 260}
                        value={url}
                    />
                    <Typography align="center">
                        {name}
                    </Typography>
                </>
            )
        } else {
            return null;
        };
    }
        , [deepLinksQuery.data, matches, props.selectedProfileId])

    return (
        <>
            {qr || <CircularProgress sx={{ alignSelf: 'center' }} />}
        </>
    );
};